import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RostoLanding from "@/pages/RostoLanding";
import MenuLanding from "@/pages/MenuLanding";
import { OrderModalProvider } from "@/components/OrderModal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <OrderModalProvider>
          <Routes>
            <Route path="/" element={<RostoLanding />} />
            <Route path="/menu" element={<MenuLanding />} />
          </Routes>
        </OrderModalProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
